module.exports = __webpack_public_path__ + "static/media/Week 3 Monday.11cc65f2.png";